module.exports = "/static/media/lineto-circular-blackitalic.ec9ac601.woff2";